'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyOrIndexToProperty = require('./keyOrIndexToProperty');

var _keyOrIndexToProperty2 = _interopRequireDefault(_keyOrIndexToProperty);

var _updateChild = require('./updateChild');

var _updateChild2 = _interopRequireDefault(_updateChild);

var _updateChildKeys = require('./updateChildKeys');

var _updateChildKeys2 = _interopRequireDefault(_updateChildKeys);

var _identity = require('unmutable/lib/identity');

var _identity2 = _interopRequireDefault(_identity);

var _has = require('unmutable/lib/has');

var _has2 = _interopRequireDefault(_has);

var _merge = require('unmutable/lib/merge');

var _merge2 = _interopRequireDefault(_merge);

var _set = require('unmutable/lib/set');

var _set2 = _interopRequireDefault(_set);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _updateIn = require('unmutable/lib/updateIn');

var _updateIn2 = _interopRequireDefault(_updateIn);

var _pipe = require('unmutable/lib/util/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key, input) {
    return function (parcelData) {
        var property = (0, _keyOrIndexToProperty2.default)(key)(parcelData);
        return (0, _pipeWith2.default)(parcelData, (0, _has2.default)('value')(input) ? (0, _update2.default)('value', (0, _set2.default)(property, input.value)) : (0, _identity2.default)(), (0, _updateChild2.default)(), (0, _updateIn2.default)(['child', property], (0, _pipe2.default)(input.child ? (0, _set2.default)('child', input.child) : (0, _identity2.default)(), (0, _has2.default)('meta')(input) ? (0, _update2.default)('meta', {}, (0, _merge2.default)(input.meta)) : (0, _identity2.default)())), (0, _updateChildKeys2.default)());
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/set.js
// module id = 345
// module chunks = 35783957827783